import React, { useEffect, useMemo, useState } from 'react';
import '../../styles/prepare-up-home.css';
import '../../styles/prepare-up-hub.css';
import '../../styles/prepare-up-interviews.css';
import { HomeSearch, ThemeToggle, buildSearchEntries } from './HomeDashboard';
import { buildPaths, getHubTreeCached } from './paths';

/** The hub tree (shared cache) — search, role scope and practice links all read it. */
export const useHubTree = () => {
  const [hub, setHub] = useState(null);
  useEffect(() => { getHubTreeCached().then((d) => setHub(d.tree || [])).catch(() => setHub([])); }, []);
  return hub;
};

/*
 * IvShell — the Interviews pages' frame: the same top search, theme toggle and
 * profile treatment as Home, Practice and Progress.
 */
const IvShell = ({ hub, profile, onEditProfile, theme, onToggleTheme, onOpenHubNode, onOpenPath, className = '', children, overlay }) => {
  const paths = useMemo(() => (hub ? buildPaths(hub) : null), [hub]);
  const entries = useMemo(() => buildSearchEntries(hub, paths ? [...paths.roles, ...paths.areas] : []), [hub, paths]);
  const displayName = profile?.display_name || profile?.name || '';
  return (
    <div className={`pu-home pu-hub pu-iv ${className}`}>
      <div className="pu-page">
        <header className="pu-topbar">
          <HomeSearch entries={entries} onPick={(e) => (e.kind === 'track' ? onOpenPath?.(e.id) : onOpenHubNode?.(e.id))} />
          <div className="pu-topbar-end">
            {onToggleTheme && <ThemeToggle theme={theme} onToggle={onToggleTheme} />}
            <button type="button" className="pu-avatar" onClick={onEditProfile} aria-label={displayName ? `${displayName} — profile` : 'Profile'}>
              {profile?.avatar ? <img src={profile.avatar} alt="" /> : <span>{(displayName || 'U').slice(0, 1).toUpperCase()}</span>}
            </button>
          </div>
        </header>
        {children}
      </div>
      {overlay}
    </div>
  );
};

export default IvShell;
